import { NeutralColors, SharedColors, YammerColors } from './yammerPalette';

export const staticFluentColors: typeof SharedColors & typeof NeutralColors & typeof YammerColors = {
  ...SharedColors,
  ...NeutralColors,
  ...YammerColors,
};
export type FluentColor = keyof typeof staticFluentColors;
